export default function ProblemSection() {
  const reasons = [
    {
      icon: "ri-eye-off-line",
      text: "You weren't top of mind when it mattered",
      detail: "Agents close with who they remember. Out of sight means out of business — every single time.",
    },
    {
      icon: "ri-chat-off-line",
      text: "You weren't in the conversation",
      detail: "Closings get decided in side conversations you were never invited to.",
    },
    {
      icon: "ri-history-line",
      text: "You showed up after the decision was already made",
      detail: "Timing is everything. By the time you reach out, the preferred title company is already selected.",
    },
  ];

  return (
    <section className="bg-alt-bg py-14 md:py-24 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-16">
          <h2
            className="text-navy font-semibold mb-6"
            style={{ fontSize: "clamp(28px, 3.5vw, 40px)", lineHeight: "1.2" }}
          >
            Title Companies Don&apos;t Lose Closings Because of Effort
          </h2>

          {/* Mobile — stacked micro-lines */}
          <div className="sm:hidden flex flex-col items-center text-[#4a5568] text-base">
            <span className="mb-2">They work hard.</span>
            <span className="mb-2">They follow up.</span>
            <span className="mb-5">They network.</span>
            <span className="mb-5">and still lose closings</span>
            <strong className="text-navy mb-2">Not because of effort &mdash;</strong>
            <strong className="text-navy mb-6">because of timing.</strong>
            <span className="text-sm text-[#4a5568]">They weren&apos;t there when the decision was made.</span>
          </div>

          {/* Desktop — original prose */}
          <p className="hidden sm:block text-[#4a5568] text-lg" style={{ lineHeight: "1.65" }}>
            They work hard. They follow up. They network.
            <br />
            And they still lose closings they should have won — because they weren&apos;t there at the right moment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 md:mb-16">
          {reasons.map((item) => (
            <div key={item.text} className="bg-white rounded-2xl p-7 border border-gray-100">
              <div className="w-11 h-11 flex items-center justify-center bg-orange-50 rounded-xl mb-5">
                <i className={`${item.icon} text-primary text-xl`} />
              </div>
              <h3 className="text-navy font-semibold text-base mb-2">{item.text}</h3>
              <p className="text-[#4a5568] text-sm leading-relaxed">{item.detail}</p>
            </div>
          ))}
        </div>

        {/* Closing statement */}
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-[#4a5568] text-lg mb-4" style={{ lineHeight: "1.65" }}>
            By the time you hear about the closing,{" "}
            <strong className="text-navy">someone else already owns the relationship.</strong>
          </p>
          <p className="text-[#4a5568] text-base mb-8 italic" style={{ lineHeight: "1.65" }}>
            And the worst part — you never even knew the opportunity was there.
          </p>
          <div className="inline-flex flex-wrap items-center justify-center gap-3 bg-navy text-white rounded-2xl px-5 md:px-8 py-4">
            <span className="w-8 h-8 flex items-center justify-center bg-primary rounded-lg flex-shrink-0">
              <i className="ri-flashlight-line text-white text-base" />
            </span>
            <span className="text-base md:text-xl font-bold tracking-tight text-center">Take Back Control of Your Market</span>
          </div>
        </div>
      </div>
    </section>
  );
}
